'use strict';

import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { addToCartItem } from '@jspartials/cart-utils';
import { gtmGetListName } from '@jspartials/gtm-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { customEvent } from '@jspartials/general-utils';

// Selectors
const selector = {
  wrapper: '.js-add-extra-item-wrapper',
  modal: 'modal_addExtraItem',
  button: {
    addExtraItem: '.js-add-extra-item-button'
  }
};

// Elements
const element = {
  wrapper: null,
  modal: null,
  button: {
    addExtraItem: []
  }
};

// Variables
let extraItemProductId = null;

/**
 * Initialize the add extra item functionality
 * @returns {void}
 */
const listenAddExtraItem = () => {
  initElementsAndVariables();
  listenAddExtraItemButtons();

  // Listen for the modal-opened event to add the event listener to the buttons inside the modal to add the extra item to the cart
  document.addEventListener('modal-opened', function (e) {
    if (e.detail === selector.modal) {
      listenAddExtraItemButtons();
    }
  });

  // Listen for the itemRemoved event to show the extra item when it is removed from the cart
  document.addEventListener(customEvent.cart.itemRemoved, function (e) {
    const { itemId: productId = '' } = e.detail;

    if (productId === extraItemProductId) {
      showElements();
    }
  });
};

/**
 * Initialize the elements and variables
 * @returns {void}
 */
const initElementsAndVariables = () => {
  element.wrapper = document.querySelector(selector.wrapper) || null;
  element.modal = document.getElementById(selector.modal) || null;
  element.button.addExtraItem =
    document.querySelectorAll(selector.button.addExtraItem) || [];

  extraItemProductId = element.wrapper?.dataset?.productId;
};

/**
 * Listen the click event on the add extra item buttons to add the extra item to the cart
 * @returns {void}
 */
const listenAddExtraItemButtons = () => {
  element.button.addExtraItem.forEach((button) => {
    listenDOMEvent(button, 'click', addExtraItemToCart);
  });
};

/**
 * Add the extra item to the cart
 * @param {Event} e - The event object
 * @returns {void}
 */
const addExtraItemToCart = (e) => {
  const button = e.currentTarget;
  const gtmListName = gtmGetListName(button);

  if (extraItemProductId) {
    addClassToElement(button, classes.is.loading);

    addToCartItem(extraItemProductId, 1, gtmListName, [])
      .then(() => {
        hideElements();
      })
      .catch((error) => {
        console.error(error);
      })
      .then(() => {
        removeClassToElement(button, classes.is.loading);
      });
  }
};

/**
 * Hide the elements
 * @returns {void}
 */
const hideElements = () => {
  closeModal();

  if (element.wrapper) {
    removeClassToElement(element.wrapper, classes.is.visible);
  }
};

/**
 * Show the elements
 * @returns {void}
 */
const showElements = () => {
  if (element.wrapper) {
    addClassToElement(element.wrapper, classes.is.visible);
  }
};

/**
 * Close the modal
 * @returns {void}
 */
const closeModal = () => {
  if (element.modal) {
    const closeElementModal = element.modal.querySelector(
      '.js-modal-trigger-close'
    );

    if (closeElementModal) {
      closeElementModal.dispatchEvent(new Event('click'));
    }
  }
};

export { listenAddExtraItem };
